import { Box, Grid, Skeleton, Stack } from "@mui/material";

/**
 * SummarySkeleton — 2-column card grid matching the Summary tab layout.
 * Left col: About card (badges + readme) + Environments card.
 * Right col: Details card + Activity card.
 */
export function SummarySkeleton(): React.ReactElement {
  const cardSx = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    p: 2.5,
    bgcolor: "background.paper",
  };

  return (
    <Grid container spacing={3}>
      {/* Left column */}
      <Grid item xs={12} md={8}>
        <Stack spacing={2.5}>
          {/* About card */}
          <Box sx={cardSx}>
            <Skeleton variant="text" width={80} height={16} sx={{ mb: 2 }} />
            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <Skeleton variant="rounded" width={120} height={28} />
              <Skeleton variant="rounded" width={130} height={28} />
              <Skeleton variant="rounded" width={80} height={28} />
            </Stack>
            <Skeleton variant="rounded" width="100%" height={80} />
          </Box>

          {/* Environments card */}
          <Box sx={cardSx}>
            <Skeleton variant="text" width={110} height={16} sx={{ mb: 2 }} />
            <Grid container spacing={1.5}>
              {[1, 2, 3].map((i) => (
                <Grid item xs={12} sm={4} key={i}>
                  <Skeleton variant="rounded" width="100%" height={80} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Stack>
      </Grid>

      {/* Right column */}
      <Grid item xs={12} md={4}>
        <Stack spacing={2.5}>
          {/* Details card */}
          <Box sx={cardSx}>
            <Skeleton variant="text" width={70} height={16} sx={{ mb: 2 }} />
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton
                key={i}
                variant="text"
                width="100%"
                height={20}
                sx={{ mb: 1 }}
              />
            ))}
          </Box>

          {/* Activity card */}
          <Box sx={cardSx}>
            <Skeleton variant="text" width={120} height={16} sx={{ mb: 2 }} />
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="text"
                width="100%"
                height={20}
                sx={{ mb: 1 }}
              />
            ))}
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default SummarySkeleton;
